export const KeyCodes = {
    ENTER: 13,
    TAB: 9,
    ARROW_DOWN: 40,
    ARROW_UP: 38,
    ESCAPE: 27,
};
